import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {COUNT_MS_IN_ONE_DAY} from '@/constants';
import {GlobalWindow, ISOString, TimeToConfig} from '@/types';

export class DateTimeService {
  constructor(private readonly globalWindow: GlobalWindow) {}

  public todayDateToIsoString = (): string => {
    return new this.globalWindow.Date().toISOString();
  };

  public timeToSec = ({seconds = 0, minutes = 0, hours = 0, days = 0}: TimeToConfig): number => {
    return seconds + 60 * (minutes + 60 * (hours + 24 * days));
  };

  public timeToMs = (props: TimeToConfig): number => {
    return 1000 * this.timeToSec(props);
  };

  public diffBetweenNowAndDate = (isoString: ISOString): number => {
    return this.globalWindow.Date.now() - this.globalWindow.Date.parse(isoString);
  };

  public millisecondsToDays = (ms: number): number => {
    return Math.ceil(ms / COUNT_MS_IN_ONE_DAY);
  };

  public diffDaysBetweenDateAndNow = (isoString: ISOString): number => {
    const ms = -this.diffBetweenNowAndDate(isoString);

    if (ms <= 0) {
      return 0;
    }

    return this.millisecondsToDays(ms);
  };
}

injected(DateTimeService, DI_TOKENS.globalWindow);
